import {Component, OnInit, OnDestroy, AfterViewInit, ViewChild} from '@angular/core';
import {FeedbackService} from '../_service/service.service';
import {Subject} from 'rxjs';
import {DataTableDirective} from 'angular-datatables';
import {CurrentUserDataService} from '../../../shared/_services/current-user-data.service';
import {ProcedureList} from '../../procedures/_models/procedureList.model';


@Component({
    selector: 'app-list-feedback',
    templateUrl: './list-feedback.component.html',
    styleUrls: ['./list-feedback.component.scss']
})

export class ListFeedbackComponent implements OnInit, AfterViewInit, OnDestroy {

    // Data Tables
    @ViewChild(DataTableDirective) datatableElement: DataTableDirective;
    dtOptions: any = {};
    procedures: Array<ProcedureList>;
    dtTrigger: Subject<any> = new Subject<any>();

    // Data
    feedbackList: any = [];

    // User
    userRole = [];

    // Subscriptions
    subscriptions = [];

    constructor(private feedbackService: FeedbackService,
                public currentUserData: CurrentUserDataService) {
    }


    ngOnInit(): void {
        this.dtOptions = {
            pagingType: 'full_numbers',
            pageLength: 10,
            columnDefs: [{
                targets: 5,
                orderable: false
            }, {
                targets: 3,
                render: (data, type) => {
                    const dateDisplay = data.split('-').reverse().join('/');
                    return type === 'display' || type === 'filter' ? dateDisplay : data;
                }
            }, {
                width: '1%',
                targets: [0, -1]
            }, {
                width: '20%',
                targets: [1, 2]
            }, {
                className: 'dtr-control',
                orderable: false,
                targets: -1
            }, {
                targets: 1,
                responsivePriority: 1
            }, {
                targets: 4,
                responsivePriority: 2
            }],
            initComplete: (settings, json) => {
                $('#myTable').show();
                $('#mySpinner').hide();
            },
            autoWidth: false,
            responsive: {
                details: {
                    type: 'column',
                    target: -1,
                    renderer: $.fn.dataTable['Responsive'].renderer.listHiddenNodes()
                }
            },
            dom: '<<t>pl>',
            order: [[0, 'desc']]
        };

        this.getFeedbacksByMainId();
        this.getUser();
    }

    /** Get User Data */
    getUser() {
        const getCurrentUser = this.currentUserData.getCurrentUserData().subscribe(data => {
            this.userRole = data.roles;
        });

        // Add request to unsubscribe list
        this.subscriptions.push(getCurrentUser);
    }

    /** Get Feedback Data */
    getFeedbacksByMainId() {
        const feedbackList = this.feedbackService.getFeedbacksByMainId().subscribe((response: any) => {
            this.feedbackList = response;
            
            this.dtTrigger.next();
        });

        // Add request to unsubscribe list
        this.subscriptions.push(feedbackList);
    }

    ngAfterViewInit() {
        const dtTrigger = this.dtTrigger.subscribe(() => {
            this.datatableElement.dtInstance.then((dtInstance: DataTables.Api) => {
                $('#tableSearchBox').on('keyup search input paste cut', function () {
                    return dtInstance.search(this['value']).draw();
                });
            });
        });

        // Subscription
        this.subscriptions.push(dtTrigger);
    }

    ngOnDestroy() {
        // Do not forget to unsubscribe the event
        this.dtTrigger.unsubscribe();
        this.subscriptions.forEach(sb => sb.unsubscribe());
    }
}
